<template>
    <div>
        <ts-loading-banner :loading="loading">
            <div class="ts-space-y-3">
                <div class="row">
                    <div class="col-md-12">
                        <label class="ts-text-xs required">
                            {{ $t('customerProfile.customerName') }}
                        </label>
                        <input v-model="model.customer_name" type="text" class="form-control" :class="{
                            'is-invalid': errors.has('customer_name')
                        }" />
                        <div class="invalid-feedback ts-text-xs" v-if="errors.has('customer_name')">
                            {{ errors.first('customer_name') }}
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <label class="ts-text-xs required">
                            {{ $t('customerProfile.gender') }}
                        </label>
                        <div class="ts-w-full">
                            <RadioGroup v-model="model.gender">
                                <Radio label="Male"> Male </Radio>
                                <Radio label="android"> Female </Radio>
                                <Radio label="windows"> Other </Radio>
                            </RadioGroup>
                        </div>
                        <div class="validate ts-text-xs" v-if="errors.has('gender')">
                            {{ errors.first('gender') }}
                        </div>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-md-6">
                        <label class="ts-text-xs required">
                            {{ $t('customerProfile.phoneNumber') }}
                        </label>
                        <input v-model.trim="model.contact_number" type="text" class="form-control" :class="{
                            'is-invalid': errors.has('contact_number')
                        }" />
                        <div class="invalid-feedback ts-text-xs" v-if="errors.has('contact_number')">
                            {{ errors.first('contact_number') }}
                        </div>
                    </div>
                    <div class="col-md-6">
                        <label class="ts-text-xs">
                            {{ $t('customerProfile.phoneNumber2') }}
                        </label>
                        <input v-model="model.contact_number2" type="text" class="form-control" />
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-md-6">
                        <label class="form-label ts-text-xs">
                            {{ $t('customerProfile.telegram') }}
                        </label>
                        <input v-model="model.telegram" type="text" class="form-control" />
                    </div>
                    <div class="col-md-6">
                        <label class="form-label ts-text-xs">
                            {{ $t('customerProfile.facebook') }}
                        </label>
                        <input v-model="model.facebook_account" type="text" class="form-control" />
                    </div>
                </div>
                <div class="row ts-mt-3">
                    <div class="col-md-12">
                        <h4 class="ts-uppercase ts-text-gray-500">
                            {{ $t('customerProfile.address') }}
                        </h4>
                        <div class="ts-border-blue-300 ts-border ts-rounded ts-p-3">
                            <div class="row ts-space-y-2">
                                <div class="col-md-12">
                                    <label class="ts-text-xs">
                                        {{ $t('customerProfile.province') }}
                                    </label>
                                    <a-select v-model="model.province_code" :options="provinces" showSearch
                                        :filterOption="(input, option) =>
                                            option.componentOptions.children[0].text
                                                .toLowerCase()
                                                .indexOf(input.toLowerCase()) >= 0
                                            " @change="onProvinceChange" class="ts-w-full"></a-select>
                                    <div class="validate ts-text-xs" v-if="errors.has('province_code')">
                                        {{ errors.first('province_code') }}
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <label class="ts-text-xs">
                                        {{ $t('customerProfile.district') }}
                                    </label>
                                    <a-select v-model="model.district_code" :options="districts" showSearch
                                        :filterOption="(input, option) =>
                                            option.componentOptions.children[0].text
                                                .toLowerCase()
                                                .indexOf(input.toLowerCase()) >= 0
                                            " @change="onDistrictChange" class="ts-w-full"></a-select>
                                    <div class="validate ts-text-xs" v-if="errors.has('district_code')">
                                        {{ errors.first('district_code') }}
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <label class="ts-text-xs">
                                        {{ $t('customerProfile.commune') }}
                                    </label>
                                    <a-select v-model="model.commune_code" :options="communes" showSearch :filterOption="(input, option) =>
                                        option.componentOptions.children[0].text
                                            .toLowerCase()
                                            .indexOf(input.toLowerCase()) >= 0
                                        " @change="onCommuneChange" class="ts-w-full"></a-select>
                                    <div class="validate ts-text-xs" v-if="errors.has('commune_code')">
                                        {{ errors.first('commune_code') }}
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <label class="ts-text-xs">
                                        {{ $t('customerProfile.village') }}
                                    </label>
                                    <a-select v-model="model.village_code" :options="villages" showSearch :filterOption="(input, option) =>
                                        option.componentOptions.children[0].text
                                            .toLowerCase()
                                            .indexOf(input.toLowerCase()) >= 0
                                        " class="ts-w-full"></a-select>
                                    <div class="validate ts-text-xs" v-if="errors.has('village_code')">
                                        {{ errors.first('village_code') }}
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <label class="ts-text-xs">
                                        {{ $t('customerProfile.zipCode') }}
                                    </label>
                                    <input v-model.trim="model.zip_code" type="text" class="form-control" :class="{
                                        'is-invalid': errors.has('zip_code')
                                    }" />
                                    <div class="invalid-feedback ts-text-xs" v-if="errors.has('zip_code')">
                                        {{ errors.first('zip_code') }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ts-loading-banner>
        <div :style="{
            position: 'absolute',
            bottom: 0,
            width: '100%',
            borderTop: '1px solid #e8e8e8',
            padding: '10px 16px',
            textAlign: 'right',
            left: 0,
            background: '#fff',
            borderRadius: '0 0 4px 4px'
        }">
            <ts-button class="ts-mr-2" @click.prevent="() => $emit('cancel')">
                {{ $t('cancel') }}
            </ts-button>
            <ts-button color="primary" @click.prevent="onSave" :waiting="waiting">{{ $t('save') }}</ts-button>
        </div>
    </div>
</template>
<script>
import { Errors } from 'form-backend-validation'
import { mapActions, mapState } from 'vuex'

export default {
    name: 'companyForm',
    data() {
        return {
            loading: false,
            errors: new Errors(),
            waiting: false,
            provinces: [],
            districts: [],
            communes: [],
            villages: [],
            model: {
                customer_id: 0,
                cus_type_id: 2, // for Sale
                customer_name: null,
                gender: null,
                contact_number: null,
                contact_email: null,
                facebook_account: null,
                telegram: null,
                city_province: null,
                year_of_born: null,
                account_number: null,
                is_general_customer: false,
                is_membership: false,
                is_allow_update_gps_location: false,
                membership_discount_rate: 0,
                company_name: null,
                zip_code: null,
                credit_day: 0,
                credit_amount: 0,
                province_code: null,
                disctrict_code: null,
                commune_code: null,
                village_code: null,
                sale_id: null,
                ss_id_card: null,
                contact_number2: null,
                approve_status: 2 // set default to approve
            }
        }
    },
    computed: {
        ...mapState('customer/profile', ['formViewDatas', 'edit_data']),
    },
    methods: {
        ...mapActions('customer/profile', ['getFormViewModel']),
        onSave() {
            this.waiting = true
            this.$store
                .dispatch('customer/profile/store', this.model)
                .then(response => {
                    this.notice({
                        type: 'success',
                        text: response.message
                    })
                    this.$emit('data', response.data)
                    this.$emit('cancel')
                })
                .catch(error => {
                    this.errors = new Errors(error.errors)
                    this.notice({ type: 'error', text: error.message })
                })
                .finally(() => {
                    this.waiting = false
                })
        },
        async fetchResources() {
            this.loading = true
            await this.getFormViewModel({
                fnName: 'provinces'
            })
                .then(response => {
                    this.provinces = response.data['provinces'].map(el => ({
                        value: el.province_code,
                        label: el.name_en
                    }))
                })
            this.loading = false
        },
        async onProvinceChange(value) {
            this.loading = true
            this.model.disctrict_code = null
            this.model.commune_code = null
            this.model.village_code = null

            await this.getFormViewModel({
                fnName: 'districts',
                province_code: value
            })
                .then(response => {
                    this.districts = response.data['districts'].map(el => ({
                        value: el.district_code,
                        label: el.name_en
                    }))
                })
                .finally(() => {
                    this.loading = false
                })
        },
        async onDistrictChange(value) {
            this.loading = true
            this.model.commune_code = null
            this.model.village_code = null

            await this.getFormViewModel({
                fnName: 'communes',
                district_code: value
            })
                .then(response => {
                    this.communes = response.data['communes'].map(el => ({
                        value: el.commune_code,
                        label: el.name_en
                    }))
                })
                .finally(() => {
                    this.loading = false
                })
        },
        async onCommuneChange(value) {
            this.model.village_code = null
            this.loading = true
            await this.getFormViewModel({
                fnName: 'villages',
                commune_code: value
            })
                .then(response => {
                    this.villages = response.data['villages'].map(el => ({
                        value: el.village_code,
                        label: el.name_en
                    }))
                })
                .finally(() => {
                    this.loading = false
                })
        },
        notice(not) {
            this.$Notice[not.type]({
                title: 'SERVICE TICKET',
                desc: not.text
            })
        }
    }
}
</script>
